module.exports = __webpack_public_path__ + "static/img/3-5.95ea4076.png";